import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Stable.module.scss';
import cn from 'classnames';
import { useSelector } from 'react-redux';
const Stable = ({ children, className }) => {
    const darkMode = useSelector((state) => state.settings.darkMode);
    return (_jsx("div", Object.assign({ className: cn(styles.element, className, darkMode && styles['isDarkMode']) }, { children: children })));
};
export default Stable;
